<template>
  <div class="role-container">
    <div class="action-header">
      <el-button type="primary" @click="handleAdd">添加角色</el-button>
    </div>
    <el-table
      :data="list"
      style="width: 100%">
      <el-table-column
        label="角色名称"
        prop="title">
      </el-table-column>
      <el-table-column
        :formatter="formatTime"
        label="更新时间"
        prop="updateDate">
      </el-table-column>
      <el-table-column
        :formatter="formatTime"
        label="创建时间"
        prop="createDate">
      </el-table-column>
      <el-table-column
        :formatter="formatState"
        label="状态"
        prop="status">
      </el-table-column>
      <el-table-column
        label="操作"
        width="150"
        algin="right">
        <template slot-scope="scope">
          <el-button
            size="mini"
            @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
          <el-button
            size="mini"
            type="danger"
            @click="handleDelete(scope.$index, scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- create/edit modal start -->
    <el-dialog :visible.sync="dialogVisible" :close-on-click-modal="false" :title="modalTitle" @close="resetTree" center>
      <el-form ref="dialogForm" :model="dialogForm" class="modal" label-width="100px">
        <el-form-item label="角色名称" prop="name">
          <el-input v-model="dialogForm.title" />
        </el-form-item>
        <el-form-item label="状态">
          <el-radio-group v-model="dialogForm.status">
            <el-radio :label="0">正常</el-radio>
            <el-radio :label="-1">禁用</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="权限列表">
          <el-tree
            ref="tree"
            :data="privilegeList"
            :props="defaultProps"
            :default-checked-keys="defaultCheckedKeys"
            show-checkbox
            default-expand-all
            node-key="code"
            highlight-current/>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm('dialogForm')">确 定</el-button>
      </div>
    </el-dialog>
    <!-- create/edit modal start -->
  </div>
</template>

<script>
import { getRoleList, addRole, updateRole, deleteRole,
  getPrivilegeList, getRoleById } from '@/api/site'
import { parseState } from '@/utils'
import find from 'lodash/find'
import * as moment from 'moment'

const defaultForm = {
  status: 0
}

export default {
  name: 'Roles',
  data() {
    return {
      list: [],
      privilegeList: [],
      defaultCheckedKeys: [],
      dialogForm: {},
      listLoading: true,
      isEditMode: false,
      modalTitle: '',
      dialogVisible: false,
      formLabelWidth: '120px',
      defaultProps: {
        children: 'kids',
        label: 'name'
      }

    }
  },
  created() {
    this.getList()
    this.getPrivilegeList()
  },
  methods: {
    // dialog form methods
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.isEditMode) {
            this.updateRole()
          } else {
            this.addRole()
          }
        } else {
          return false
        }
      })
    },

    resetForm(formName) {
      this.$refs[formName].resetFields()
    },
    handleAdd() {
      this.dialogVisible = true
      this.isEditMode = false
      this.modalTitle = '添加角色信息'
      this.dialogForm = defaultForm
      this.defaultCheckedKeys = []
    },
    handleEdit(index, row) {
      this.dialogForm = Object.assign({},this.list[index])
      this.defaultCheckedKeys = this.dialogForm.codes.split(',')
      this.dialogVisible = true
      this.isEditMode = true
      this.modalTitle = '编辑角色信息'
    },
    handleDelete(index, row) {
      this.$confirm('此操作将永久删除该角色, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(() => {
        this.deleteRole(this.list[index].id)
      }).catch(() => {
      })
    },
    getList() {
      getRoleList().then(response => {
        const data = response.data
        this.list = data.list
        this.listLoading = false
      })
    },
    getRoleById(id) {},
    addRole() {
      const keys = this.$refs.tree.getCheckedKeys()
      const data = {
        title: this.dialogForm.title,
        codes: keys.join(),
        status: this.dialogForm.status
      }
      addRole(data).then(response => {
        const data = response.data
        if (data && data.role) {
          this.dialogVisible = false
          this.$message({
            message: '创建成功',
            type: 'success',
            showClose: true,
            duration: 1000
          })
          this.getList()
        }
      })
    },
    updateRole() {
      const keys = this.$refs.tree.getCheckedKeys()
      const data = {
        id: this.dialogForm.id,
        title: this.dialogForm.title,
        codes: keys.join(),
        status: this.dialogForm.status
      }
      updateRole(data).then(response => {
        const data = response.data
        if (data) {
          this.$message({
            message: '更新成功',
            type: 'success',
            showClose: true,
            duration: 1000
          })
          this.getList()
        }
      })
    },
    deleteRole(id) {
      deleteRole(id).then(response => {
        const data = response.data
        if (data) {
          this.$message({
            message: '删除成功',
            type: 'success',
            showClose: true,
            duration: 1000
          })
          this.getList()
        }
      })
    },
    resetTree() {
      this.$refs.tree.setCheckedKeys([])
    },
    getPrivilegeList() {
      getPrivilegeList().then(response => {
        const data = response.data
        this.privilegeList = data.priviliges
      })
    },
    formatState: function(row, column) {
      const value = row[column.property]
      return parseState(value)
    },
    formatTime: function(row, column) {
      const value = row[column.property];
      return value && moment(value).format('YYYY-MM-DD HH:mm:ss')
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.role-container {
  margin: 30px 15px;
  .action-header {
    padding: 0 10px 10px 10px;
  }

  /* dialog modal start */
  .el-dialog {
    width: 540px;
    .el-form-item {
      .el-input {
        width: 300px;
      }
    }
  }
  /* dialog modal end*/
}
</style>
